import { useSelector } from "react-redux";

import { RootState } from "src/redux/reducers";
import { WorkspacePermissionsEnum } from "src/utils/PermissionsEnums";

export default function useCheckWorkspacePermission(
  permission: keyof typeof WorkspacePermissionsEnum,
) {
  const identity = useSelector(
    (state: RootState) => state.mainReducer.identity,
  );
  return Boolean(
    identity?.permissions?.workspace.includes(
      WorkspacePermissionsEnum[permission],
    ),
  );
}
